/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { computed, inject, Injectable, Injector, Signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SelectItemsVoModel } from '@well/common-libs/select-items/domain';
import { SelectItemsStore } from '../select-items.store';

@Injectable({
  providedIn: 'root',
})
export class SelectItemsStoreFacade {
  private store = inject(SelectItemsStore);
  private injector = inject(Injector);
  translateService = inject(TranslateService);

  // Signal API (new)
  readonly selectItemsSignal = this.store.selectItems;

  getMU() {
    const obs1: Observable<SelectItemsVoModel[]> = toObservable(
      this.store.getSelectItemsByFieldName(this.translateService.currentLang, 'volumeUnitValue'),
      { injector: this.injector }
    );
    const obs2: Observable<SelectItemsVoModel[]> = toObservable(
      this.store.getSelectItemsByFieldName(this.translateService.currentLang, 'weightUnitValue'),
      { injector: this.injector }
    );

    return combineLatest([obs1, obs2]).pipe(
      map(([obs1Res, obs2Res]) => {
        return [...obs1Res, ...obs2Res];
      })
    );
  }

  getItemsByKey(lang: string, key: string): Observable<SelectItemsVoModel | undefined> {
    return toObservable(this.store.getSelectItemByKey(lang, key), { injector: this.injector });
  }

  getSignalItemByKey(lang: string, key: string): Signal<SelectItemsVoModel | undefined> {
    return this.store.getSelectItemByKey(lang, key);
  }

  setSelectItems(locale: string, items: SelectItemsVoModel[]) {
    this.store.setSelectItems(locale, items);
  }
}
